var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('menu-pages-navbar',{staticClass:"mb-3"}),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",staticStyle:{"height":"100%","min-height":"480px"}},[_c('img',{staticStyle:{"width":"100%","height":"auto","object-fit":"contain"},attrs:{"src":_vm.explainFeatureImageUrl}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/MenuStart.vue?vue&type=template&id=f093255a&
// module id = 2420
// module chunks = 5